import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punelocalandoutstaioncab() {



    const cardData = {

keyword: "Pune Local and Outstation Cab",

headingDescription:
    "Rising Cab Service provides dependable Pune Local and Outstation Cab services for families, tourists, corporate travelers, and daily commuters. We offer comfortable local city rides, airport and railway station transfers, as well as one-way and round-trip outstation travel to popular destinations across Maharashtra and India. Our fleet includes Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles with professional drivers. With 24/7 availability, transparent pricing, and timely service, Rising Cab Service ensures a safe, convenient, and enjoyable travel experience.",

topPlaces: [
    {
        title: "Mumbai",
        description:
            "Mumbai is one of the most preferred outstation destinations from Pune, known for Gateway of India, Marine Drive, Juhu Beach, Siddhivinayak Temple, and bustling business districts. It is ideal for business trips, family vacations, and sightseeing."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a scenic hill station famous for Bhushi Dam, Tiger Point, Rajmachi Fort, and lush green valleys. Its pleasant weather and beautiful landscapes make it a favorite weekend getaway."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a popular hill station known for its strawberry farms, Venna Lake, scenic viewpoints, and cool climate. It is perfect for family holidays and romantic escapes."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India's most visited pilgrimage destinations, attracting millions of Sai Baba devotees every year. The peaceful atmosphere and sacred temple make it a popular spiritual journey."
    },
    {
        title: "Goa",
        description:
            "Goa is a world-famous tourist destination offering beautiful beaches, water sports, nightlife, historic churches, and Portuguese architecture. It is a favorite holiday spot for travelers from Pune."
    },
    {
        title: "Nashik",
        description:
            "Nashik is known for Trimbakeshwar Jyotirlinga, Panchvati, Godavari Ghats, and renowned vineyards. It offers a perfect combination of spirituality, history, and leisure tourism."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar is one of the twelve Jyotirlingas of Lord Shiva and is surrounded by the Sahyadri hills and wildlife sanctuary. It is a popular pilgrimage and nature destination."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is famous for the UNESCO-listed Ajanta and Ellora Caves, Bibi Ka Maqbara, and Daulatabad Fort, making it one of Maharashtra's top heritage destinations."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is renowned for the Mahalakshmi Temple, Panhala Fort, rich Maratha history, and traditional cuisine. It is a popular destination for cultural and spiritual tourism."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a beautiful coastal town known for its clean beaches, historic sea forts, and peaceful atmosphere. It is one of the best weekend beach destinations from Pune."
    }
],



services: [
    {
        name: "Pune Local and Outstation Cab",
        description:
            "Rising Cab Service offers Pune Local and Outstation Cab services for comfortable, safe, and affordable travel across Pune and major destinations throughout Maharashtra and India. Whether you need a cab for daily city travel, airport transfers, corporate meetings, sightseeing, family functions, or long-distance outstation journeys, we provide reliable transportation with well-maintained AC vehicles and professional drivers. Customers can choose from hatchbacks, sedans, SUVs, Ertiga, Innova, Innova Crysta, and Tempo Travellers according to their travel requirements. Our service includes instant and advance booking, transparent pricing, one-way and round-trip options, hourly rentals, and full-day packages. Popular routes include Mumbai, Shirdi, Nashik, Lonavala, Mahabaleshwar, Goa, Kolhapur, Aurangabad, Bhimashankar, Pandharpur, and many more destinations."
    },
    {
        name: "Local Cab Pune",
        description:
            "Rising Cab Service provides Local Cab Pune for daily commuting, shopping, office travel, educational trips, hospital visits, family outings, and city sightseeing. Our local cab service offers flexible booking options including hourly rentals, half-day packages, and full-day travel with experienced drivers and affordable fares."
    },
    {
        name: "Outstation Cab Pune",
        description:
            "Book Outstation Cab Pune with Rising Cab Service for safe and comfortable long-distance travel. We provide one-way and round-trip cab services to Mumbai, Shirdi, Nashik, Goa, Mahabaleshwar, Kolhapur, Aurangabad, and other popular destinations with transparent pricing and professional chauffeurs."
    },
    {
        name: "City Taxi Pune",
        description:
            "Our City Taxi Pune service offers reliable transportation for local travel across Pune with clean vehicles, punctual drivers, and affordable rates for business and personal travel."
    },
    {
        name: "Pune Day Rental Cab",
        description:
            "Rising Cab Service offers Pune Day Rental Cab packages for customers who require a dedicated vehicle for multiple destinations throughout the day with flexible travel schedules and professional drivers."
    },
    {
        name: "Hourly Cab Pune",
        description:
            "Book Hourly Cab Pune for flexible city travel with convenient rental plans suitable for meetings, shopping, local sightseeing, and personal errands."
    },
    {
        name: "Pune Intercity Cab",
        description:
            "Our Pune Intercity Cab service provides comfortable travel between Pune and nearby cities with one-way and round-trip options for business and leisure travel."
    },
    {
        name: "Local Sightseeing Cab Pune",
        description:
            "Rising Cab Service offers Local Sightseeing Cab Pune for exploring tourist attractions, temples, heritage sites, gardens, museums, and popular landmarks across Pune city."
    },
    {
        name: "Outstation Travel Cab Pune",
        description:
            "Our Outstation Travel Cab Pune service provides dependable transportation for family vacations, pilgrimages, corporate tours, and holiday trips with experienced drivers."
    },
    {
        name: "Pune Cab Hire Local",
        description:
            "Book Pune Cab Hire Local for short-distance and city travel with affordable pricing, clean AC vehicles, and flexible booking options."
    },
    {
        name: "Pune Cab Hire Outstation",
        description:
            "Rising Cab Service offers Pune Cab Hire Outstation for comfortable intercity travel with well-maintained vehicles and professional chauffeurs."
    },
    {
        name: "Full Day Cab Pune",
        description:
            "Our Full Day Cab Pune package provides a dedicated cab for complete day travel, making it ideal for sightseeing, business meetings, family functions, and local travel."
    },
    {
        name: "Half Day Cab Pune",
        description:
            "Book Half Day Cab Pune for convenient travel over a few hours with economical pricing and flexible schedules for personal and business requirements."
    },
    {
        name: "Flexible Cab Booking Pune",
        description:
            "Rising Cab Service provides Flexible Cab Booking Pune with instant and advance reservation options, allowing customers to plan travel according to their convenience."
    },
    {
        name: "Best Local Cab Pune",
        description:
            "Our Best Local Cab Pune service delivers safe, comfortable, and affordable transportation for daily city travel with trained drivers and quality vehicles."
    },
    {
        name: "Local and Outstation Cab Service Pune",
        description:
            "Rising Cab Service offers Local and Outstation Cab Service Pune for city rides, airport transfers, pilgrimage tours, family vacations, and long-distance travel across Maharashtra."
    },
    {
        name: "Pune Cab Service for Local and Outstation",
        description:
            "Our Pune Cab Service for Local and Outstation provides complete travel solutions for short-distance and long-distance journeys with reliable service and transparent fares."
    },
    {
        name: "Best Local and Outstation Cab Pune",
        description:
            "Book the Best Local and Outstation Cab Pune with Rising Cab Service for dependable transportation, experienced drivers, and comfortable vehicles."
    },
    {
        name: "24x7 Local and Outstation Taxi Pune",
        description:
            "Rising Cab Service provides 24x7 Local and Outstation Taxi Pune for round-the-clock travel with instant availability and professional customer support."
    },
    {
        name: "Cheap Local and Outstation Cab Pune",
        description:
            "Our Cheap Local and Outstation Cab Pune offers economical travel solutions for city and long-distance journeys without compromising comfort and safety."
    },
    {
        name: "Online Local and Outstation Cab Booking Pune",
        description:
            "Book Online Local and Outstation Cab Booking Pune with instant confirmation, multiple vehicle options, and transparent pricing for all travel needs."
    },
    {
        name: "Pune Local Taxi and Outstation Service",
        description:
            "Rising Cab Service provides Pune Local Taxi and Outstation Service for daily travel, airport transfers, sightseeing, and intercity transportation."
    },
    {
        name: "Pune City and Outstation Cab",
        description:
            "Our Pune City and Outstation Cab service combines local and long-distance travel solutions with affordable fares and comfortable vehicles."
    },
    {
        name: "Pune to Mumbai Cab",
        description:
            "Rising Cab Service offers Pune to Mumbai Cab with one-way and round-trip options for business, airport transfers, and family travel."
    },
    {
        name: "Pune to Shirdi Taxi",
        description:
            "Book Pune to Shirdi Taxi for comfortable Sai Baba darshan trips with experienced drivers and flexible travel packages."
    },
    {
        name: "Pune to Goa Cab",
        description:
            "Our Pune to Goa Cab service provides safe and comfortable long-distance travel for family holidays and leisure trips."
    },
    {
        name: "Pune to Mahabaleshwar Taxi",
        description:
            "Rising Cab Service offers Pune to Mahabaleshwar Taxi with comfortable vehicles and scenic road travel for weekend getaways."
    },
    {
        name: "Pune to Nashik Cab",
        description:
            "Book Pune to Nashik Cab for business travel, temple visits, and family trips with reliable and affordable transportation."
    },
    {
        name: "Pune to Kolhapur Taxi",
        description:
            "Our Pune to Kolhapur Taxi service offers convenient long-distance travel with professional drivers and clean AC vehicles."
    },
    {
        name: "Pune Airport to City Cab",
        description:
            "Rising Cab Service provides Pune Airport to City Cab with timely pickups, comfortable vehicles, and dependable airport transfer solutions."
    },
    {
        name: "Pune to Lonavala Cab",
        description:
            "Book Pune to Lonavala Cab with Rising Cab Service for weekend trips, sightseeing, and family vacations with affordable one-way and round-trip packages."
    }
],

tableData: [
    ["Pune Local and Outstation Cab", "Local Cab Pune"],
    ["Outstation Cab Pune", "City Taxi Pune"],
    ["Pune Day Rental Cab", "Hourly Cab Pune"],
    ["Pune Intercity Cab", "Local Sightseeing Cab Pune"],
    ["Outstation Travel Cab Pune", "Pune Cab Hire Local"],
    ["Pune Cab Hire Outstation", "Full Day Cab Pune"],
    ["Half Day Cab Pune", "Flexible Cab Booking Pune"],
    ["Best Local Cab Pune", "Local and Outstation Cab Service Pune"],
    ["Pune Cab Service for Local and Outstation", "Best Local and Outstation Cab Pune"],
    ["24x7 Local and Outstation Taxi Pune", "Cheap Local and Outstation Cab Pune"],
    ["Online Local and Outstation Cab Booking Pune", "Pune Local Taxi and Outstation Service"],
    ["Pune City and Outstation Cab", "Pune to Mumbai Cab"],
    ["Pune to Shirdi Taxi", "Pune to Goa Cab"],
    ["Pune to Mahabaleshwar Taxi", "Pune to Nashik Cab"],
    ["Pune to Kolhapur Taxi", "Pune Airport to City Cab"],
    ["Pune to Lonavala Cab", "Pune Local and Outstation Cab"]
],




whychoose: [
    {
        WhyChooseheading: "Complete Local and Outstation Travel Solutions",
        WhyChoosedescription: "Rising Cab Service provides dependable transportation for local city rides, airport transfers, railway station pickups, business travel, sightseeing tours, and outstation journeys from Pune."
    },
    {
        WhyChooseheading: "Travel Anywhere with Ease",
        WhyChoosedescription: "From short-distance travel within Pune to long-distance trips across Maharashtra and neighboring states, our cab services are designed for every travel requirement."
    },
    {
        WhyChooseheading: "Extensive Fleet for Every Journey",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and comfort preferences."
    },
    {
        WhyChooseheading: "Ideal for Daily and Occasional Travel",
        WhyChoosedescription: "Whether it's office commuting, shopping, family outings, medical visits, vacations, or religious tours, we offer suitable transportation options."
    },
    {
        WhyChooseheading: "Popular Outstation Routes Covered",
        WhyChoosedescription: "Our services connect Pune with destinations such as Mumbai, Shirdi, Nashik, Mahabaleshwar, Lonavala, Goa, Kolhapur, Aurangabad, and many other cities."
    },
    {
        WhyChooseheading: "Convenient Pickup from All Pune Locations",
        WhyChoosedescription: "Pickup and drop facilities are available across Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby areas."
    },
    {
        WhyChooseheading: "Professional Drivers and Comfortable Rides",
        WhyChoosedescription: "Our experienced drivers and well-maintained vehicles ensure smooth, safe, and comfortable travel for every passenger."
    },
    {
        WhyChooseheading: "Flexible Travel Packages and Booking Options",
        WhyChoosedescription: "Rising Cab Service offers one-way trips, round trips, hourly rentals, full-day packages, and customized travel plans based on customer requirements."
    }
]
};

const faqData = [
    {
        question: "What services are included in Pune Local and Outstation Cab bookings?",
        answer: "Customers can book local city travel, airport transfers, railway station pickups, sightseeing tours, one-way trips, round trips, and outstation travel services."
    },
    {
        question: "Which destinations are frequently visited through outstation cab services?",
        answer: "Popular destinations include Mumbai, Shirdi, Nashik, Mahabaleshwar, Goa, Kolhapur, Aurangabad, Lonavala, and many other tourist and business locations."
    },
    {
        question: "Can customers hire cabs for full-day local travel in Pune?",
        answer: "Yes, full-day and hourly cab rental options are available for local city transportation and personal travel requirements."
    },
    {
        question: "Are airport and railway station transfers available?",
        answer: "Yes, we provide convenient pickup and drop services for Pune Airport, Pune Railway Station, and other transportation hubs."
    },
    {
        question: "What vehicle categories can be booked?",
        answer: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles."
    },
    {
        question: "Do you provide cabs for family vacations and group tours?",
        answer: "Yes, family trips, weekend getaways, religious tours, and group travel arrangements can be easily organized."
    },
    {
        question: "Can corporate employees use local and outstation cab services?",
        answer: "Yes, our services are frequently utilized for office travel, client meetings, business visits, and executive transportation."
    },
    {
        question: "Are one-way and round-trip bookings available?",
        answer: "Yes, customers can choose either one-way transportation or complete return-trip packages."
    },
    {
        question: "Is advance booking recommended for outstation travel?",
        answer: "Yes, advance reservations help ensure vehicle availability, especially during weekends and festive travel seasons."
    },
    {
        question: "How can I book a Pune Local and Outstation Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vaibhav Patil",
        feedback:
            "From local Pune travel to weekend outstation trips, Rising Cab Service has always delivered dependable transportation. The vehicles are comfortable, and the service quality remains consistent.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sonal Deshmukh",
        feedback:
            "Recently used their service for both city travel and a family vacation outside Pune. Everything was handled professionally, and the overall travel experience was extremely satisfying.",
        rating: 5
    }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Local and Outstation Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-local-outstation-cab.jpg",
"description": "Book Pune Local and Outstation Cab Service with Rising Cab Service for city travel, hourly rentals, sightseeing tours, and intercity trips. Enjoy flexible, affordable, and 24x7 taxi service with AC cars and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-local-outstation-cab"
}
};




    return (
        <div>
<Helmet>
  <title>Pune Local & Outstation Cab Service | 24x7 Taxi Rental | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune Local and Outstation Cab Service for hourly rentals, city travel, sightseeing, and intercity trips. Affordable 24x7 taxi service with flexible booking and AC cars."
/>

<meta
 name="keywords"
 content="Pune local and outstation cab, local cab pune, outstation cab pune, city taxi pune, pune day rental cab, hourly cab pune, pune intercity cab, local sightseeing cab pune, outstation travel cab pune, pune cab hire local, pune cab hire outstation, full day cab pune, half day cab pune, flexible cab booking pune, best local cab pune, Local and Outstation Cab Service Pune, Pune Cab Service for Local and Outstation, Best Local and Outstation Cab Pune, 24x7 Local and Outstation Taxi Pune, Cheap Local and Outstation Cab Pune, Online Local and Outstation Cab Booking Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punelocalandoutstaioncab;